import { RQ } from 'utils';

export default {
  authorizeMeitu: async function (inviteCode) {
    let self = this;
    let uri = 'https://openapi.account.meitu.com/oauth/authorize?client_id=#clientId#&response_type=code&redirect_uri=#redirectUri#&state=#state#';
    uri = uri.replace('#clientId#', '2016868244');
    uri = uri.replace('#redirectUri#', 'https://mc.meidd.com/app/meitu/redirect');
    uri = uri.replace('#state#', inviteCode);
    window.location.href = uri;
  },
  loginByCode: async function (code, state) {
    let params = {
      code: code,
      state: state
    }
    console.log('loginByCode-params===>', params);
    const d = await RQ.mall.get('/api/app/meitu/loginByCode', params, {});
    if (d && d.code == 0) {
      G.member = d.data;
      G.enterprise = d.data.enterpriseNo;
      let acIds = state.split('-');
      localStorage.setItem(acIds[0], JSON.stringify(G.member));
      await this.jumpActivity(state);
    }
  },
  jumpActivity: async function (state) {
    const route = {
      path: `/app/meitu/activity`,
      query: {
        acId: state
      }
    };
    this.$router.push(route);
  }
};



// WEBPACK FOOTER //
// ./src/module/app/meituAuth/action.js